import React from 'react';
import { Grid, Typography } from '@mui/material';
import { checkString } from '../../../../../../core/standardFunctions';
import { IMortgage } from '../../../../../../../Interfaces/IMortgage';
import { ILandParcelEntry } from '../../../../../../../Interfaces/IRealEstate';

interface IProps {
  mortgageObject: IMortgage;
}

export const RealEstateSummary: React.FC<IProps> = ({ mortgageObject }) => {
  const { RealEstate, RealEstateLandRegistryData } = mortgageObject;

  return (
    <>
      {RealEstateLandRegistryData === 'yes' ? (
        <Grid container spacing={2} sx={{ ml: 0, mt: 2 }}>
          <Grid item xs={12}>
            <Typography sx={{ mt: 5 }} variant='h6'>
              Grundbuchinformationen
            </Typography>
            <hr />
          </Grid>

          {Array.isArray(RealEstate.LandParcelEntryArray) &&
          RealEstate.LandParcelEntryArray.length > 0 ? (
            RealEstate.LandParcelEntryArray.map(
              (eintrag: ILandParcelEntry, idx: number) => (
                <React.Fragment key={`gb-entry-${idx}`}>
                  {/* Divider zwischen Einträgen */}
                  {idx > 0 && (
                    <Grid item xs={12}>
                      <hr />
                    </Grid>
                  )}

                  {/* Kopfzeile pro Eintrag */}
                  <Grid item xs={12}>
                    <Typography
                      variant='subtitle1'
                      sx={{ mt: idx === 0 ? 2 : 1 }}
                    >
                      Eintrag {idx + 1}:
                    </Typography>
                  </Grid>

                  {/* Amtsgericht */}
                  <Grid item sm={4}>
                    <b>Amtsgericht:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {eintrag.Court
                      ? `${checkString(eintrag.Court.Court)} | ${checkString(
                          eintrag.Court.FederalState
                        )}`
                      : 'k.A.'}
                  </Grid>

                  {/* Grundbuch */}
                  <Grid item sm={4}>
                    <b>Grundbuch:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {checkString(eintrag.LandRegister)}
                  </Grid>

                  {/* Blatt */}
                  <Grid item sm={4}>
                    <b>Blatt:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {checkString(eintrag.SheetLandRegister)}
                  </Grid>

                  {/* Flur */}
                  <Grid item sm={4}>
                    <b>Flur:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {checkString(eintrag.Parcel)}
                  </Grid>

                  {/* Flurstück */}
                  <Grid item sm={4}>
                    <b>Flurstück:</b>
                  </Grid>
                  <Grid item sm={8}>
                    {checkString(eintrag.LandParcel)}
                  </Grid>
                </React.Fragment>
              )
            )
          ) : (
            <Grid item xs={12}>
              <Typography variant='body2' sx={{ mt: 1 }}>
                Keine Grundbuch‐Einträge vorhanden.
              </Typography>
            </Grid>
          )}
        </Grid>
      ) : (
        <Grid container spacing={2} sx={{ ml: 0, mt: 2 }}>
          <Grid item xs={12}>
            <Typography sx={{ mt: 5 }} variant='h6'>
              Objekt
            </Typography>
            <hr />
          </Grid>

          <Grid item sm={4}>
            <b>Straße:</b>
          </Grid>
          <Grid item sm={8}>
            {checkString(RealEstate.Street)}
          </Grid>

          <Grid item sm={4}>
            <b>Adresszusatz:</b>
          </Grid>
          <Grid item sm={8}>
            {checkString(RealEstate.StreetAditional)}
          </Grid>

          <Grid item sm={4}>
            <b>Hausnummer:</b>
          </Grid>
          <Grid item sm={8}>
            {checkString(RealEstate.StreetNr)}
          </Grid>

          <Grid item sm={4}>
            <b>Postleitzahl:</b>
          </Grid>
          <Grid item sm={8}>
            {checkString(RealEstate.Postcode)}
          </Grid>

          <Grid item sm={4}>
            <b>Ort:</b>
          </Grid>
          <Grid item sm={8}>
            {checkString(RealEstate.City)}
          </Grid>
        </Grid>
      )}
    </>
  );
};
